var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupplyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600.1 732.7",
    style: {
      enableBackground: "new 0 0 600.1 732.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000121280277609432730910000014452494763701191064_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M433.4,133.3H250V66.7h83.3c18.4,0,33.3-14.9,33.3-33.3S351.8,0,333.4,0H100C81.6,0,66.7,14.9,66.7,33.3 S81.6,66.7,100,66.7h83.3v66.7H50C23.4,132.4,1,153.3,0,179.9c0,1.1,0,2.3,0,3.4v133.3c-0.9,26.7,19.9,49.1,46.6,50 c1.1,0,2.3,0,3.4,0h316.7v116.7c-0.9,26.7,19.9,49.1,46.6,50c1.1,0,2.3,0,3.4,0H550c26.7,0.9,49.1-19.9,50-46.6 c0-1.1,0-2.3,0-3.4V300C600,208,525.4,133.3,433.4,133.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.4,566.7l-50,56.7c-24,26.7-21.8,67.8,4.9,91.8c0.6,0.5,1.2,1,1.8,1.5c24.9,21.3,61.7,21.3,86.7,0 c27.5-23,31.2-64,8.2-91.6c-0.5-0.6-1-1.2-1.5-1.8L483.4,566.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplyIcon);
export default __webpack_public_path__ + "static/media/supply_icon.2a3379355f2373c5dcffb1999400a2fc.svg";
export { ForwardRef as ReactComponent };